const listeners = new Set();

const emit = (payload) => {
  listeners.forEach((listener) => listener(payload));
};

const createNotifier = (type) => (message, options = {}) => {
  if (!message) return;
  emit({
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    type,
    message: String(message),
    duration: typeof options.duration === 'number' ? options.duration : 4200,
  });
};

const notify = createNotifier('info');

notify.success = createNotifier('success');
notify.error = createNotifier('error');
notify.warning = createNotifier('warning');
notify.info = createNotifier('info');
notify.subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export default notify;
